import { render } from "./item.vue?vue&type=template&id=147d4ec8"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"
script.render = render

export default script